import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import { getMemberChanges } from '../../api/calls';
import '../CheckInModal/modalOverwrite.css';

const thStyle = {
    userSelect: 'none',
    backgroundColor: '#4a6fa5',
    color: '#fff',
    borderColor: '#3a5a8f',
};

const SectionHeader = ({ title, count }) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '0.5rem',
    }}>
        <h5 style={{ margin: 0 }}>{title}</h5>
        <span style={{
            backgroundColor: '#4a6fa5',
            color: '#fff',
            borderRadius: '12px',
            padding: '1px 10px',
            fontSize: '0.85rem',
            fontWeight: 600,
        }}>{count}</span>
    </div>
);

const MemberTable = ({ rows }) => (
    <Table striped bordered size="sm">
        <thead>
            <tr>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Phone</th>
            </tr>
        </thead>
        <tbody>
            { rows.length === 0 && (
                <tr><td colSpan={4} className="text-center text-muted">None</td></tr>
            )}
            { rows.map(m => (
                <tr key={m.PK}>
                    <td>{ m.lastName }, { m.firstName }</td>
                    <td>{ m.customerType }</td>
                    <td>{ m.email }</td>
                    <td>{ m.mobile || '—' }</td>
                </tr>
            ))}
        </tbody>
    </Table>
);

const MemberChangesModal = ({ show, onHide }) => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        if (show) {
            setLoading(true);
            getMemberChanges(currentYear).then(data => {
                setMembers(data ?? []);
                setLoading(false);
            });
        } else {
            setMembers([]);
        }
    }, [show, currentYear]);

    const byLastName = (a, b) => a.lastName.localeCompare(b.lastName);

    const newMembers = members
        .filter(m => m.yearJoin === currentYear)
        .sort(byLastName);

    const canceledMembers = members
        .filter(m => m.yearCanceled === currentYear)
        .sort(byLastName);

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-90w" centered>
            <Modal.Header closeButton style={{ backgroundColor: '#4a6fa5', color: '#fff' }}>
                <Modal.Title>Member Changes {currentYear}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: '#f5f7fa' }}>
                { loading && (
                    <div className="d-flex justify-content-center py-4">
                        <Spinner animation="border" />
                    </div>
                )}
                { !loading && (
                    <>
                        <SectionHeader title="New Members" count={newMembers.length} />
                        <MemberTable rows={newMembers} />

                        <div style={{ marginTop: '1.5rem' }}>
                            <SectionHeader title="Canceled Members" count={canceledMembers.length} />
                            <MemberTable rows={canceledMembers} />
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default MemberChangesModal;
